import * as React from "react";
import { forwardRef } from "react";
const SvgCloseIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.333 10a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 1 1 16.666 0M7.475 7.475a.625.625 0 0 1 .883 0L10 9.117l1.642-1.642a.625.625 0 0 1 .883.883L10.883 10l1.642 1.642a.625.625 0 0 1-.883.883L10 10.883l-1.642 1.642a.625.625 0 0 1-.883-.883L9.117 10 7.475 8.358a.625.625 0 0 1 0-.883", fill: "currentColor", opacity: 0.48 }));
const ForwardRef = forwardRef(SvgCloseIcon);
export default ForwardRef;
